import type { VolunteerFormState } from './types';

export const volunteerStepItems = [
  { key: 'pbl.lawyerRegistration.steps.personalInformation', defaultLabel: 'Personal Information' },
  { key: 'pbl.lawyerRegistration.steps.practiceInformation', defaultLabel: 'Practice Information' },
  { key: 'pbl.lawyerRegistration.steps.serviceAreas', defaultLabel: 'Pro Bono Legal Service Areas' },
  { key: 'pbl.lawyerRegistration.steps.profileCv', defaultLabel: 'Profile & CV' },
  { key: 'pbl.lawyerRegistration.steps.authorisation', defaultLabel: 'Authorisation from Law Firm' },
  { key: 'pbl.lawyerRegistration.steps.servicePledge', defaultLabel: 'Service Pledge / Agreements' },
  { key: 'pbl.lawyerRegistration.steps.postCompletion', defaultLabel: 'Post Completion of Pro Bono Service' },
  {
    key: 'pbl.lawyerRegistration.steps.personalInformationCollection',
    defaultLabel: 'Personal Information Collection Statement',
  },
  { key: 'pbl.lawyerRegistration.steps.conductCheck', defaultLabel: 'Conduct Check' },
  { key: 'pbl.lawyerRegistration.steps.declaration', defaultLabel: 'Declaration' },
  { key: 'pbl.lawyerRegistration.steps.reviewSubmit', defaultLabel: 'Review & Submit' },
];

export const volunteerSteps = volunteerStepItems.map((item) => item.key);

export const initialVolunteerForm: VolunteerFormState = {
  surname_en: '',
  given_name_en: '',
  surname_zh: '',
  given_name_zh: '',
  full_name_en: '',
  full_name_zh: '',
  phone: '',
  phone_otp: '',
  phone_otp_verified: false,
  email: '',
  email_otp: '',
  email_otp_verified: false,
  email_verification_token: '',
  email_verification_code: '',
  password: '',
  password_confirmation: '',
  hk_solicitor_admission_year: '',
  other_professional_qualifications: [],
  other_professional_qualification_text: '',
  language_proficiency: [],
  language_other_text: '',
  law_firm_name: '',
  law_firm_name_zh: '',
  position_in_law_firm: '',
  position_other_text: '',
  service_areas: [],
  cv_publication_consent: false,
  cv_full_name_en: '',
  cv_full_name_zh: '',
  cv_law_firm_en: '',
  cv_law_firm_zh: '',
  cv_position_en: '',
  cv_position_zh: '',
  cv_admission_year_en: '',
  cv_admission_year_zh: '',
  cv_other_qualifications_en: '',
  cv_other_qualifications_zh: '',
  cv_languages_en: '',
  cv_languages_zh: '',
  cv_primary_practice_areas_en: '',
  cv_primary_practice_areas_zh: '',
  cv_professional_experience_en: '',
  cv_professional_experience_zh: '',
  cv_pro_bono_experience_en: '',
  cv_pro_bono_experience_zh: '',
  cv_signature: '',
  cv_signed_at: '',
  firm_authorisation_template_downloaded: false,
  firm_authorisation_file_id: undefined,
  firm_authorisation_file: null,
  firm_authorisation_confirmed: false,
  firm_authorisation_letter_attached: false,
  law_firm_change_notify_agreed: false,
  service_pledge_agreed: false,
  post_completion_agreed: false,
  pics_agreed: false,
  bankrupt_or_insolvent: undefined,
  arrangement_with_creditors: undefined,
  criminal_conviction: undefined,
  professional_misconduct_or_pending_disciplinary: undefined,
  suspended_from_professional_practice: undefined,
  conduct_supporting_document_file_id: undefined,
  conduct_supporting_document_file: null,
  declaration_signature: '',
  declaration_signed_at: '',
  review_confirmed: true,
};
